import {subscribeToSocketsAndWaitConnected} from 'iqos-mw';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import deviceStateService from '@/services/device/deviceStateService';
import log from '@/services/logger/log';
import mwStateService from '@/services/mw/mwStateService';
import {
    selectIsConnectingToIot,
    selectIsDeviceConnectedToIot,
    selectIsDeviceWebSocketDisconnected,
    selectIsHolderConnectedToIot,
    selectIsHolderWebSocketDisconnected,
} from '@/state/selectors/device';
import {selectIsHolderConnected} from '@/state/selectors/mw';
import {setIsDeviceWebSocketDisconnected, setIsHolderWebSocketDisconnected} from '@/state/slices/deviceSlice';
import {dispatch} from '@/state/store';

const useIotWebSocketReconnect = () => {
    const isDeviceWebSocketDisconnected = useSelector(selectIsDeviceWebSocketDisconnected);
    const isHolderWebSocketDisconnected = useSelector(selectIsHolderWebSocketDisconnected);
    const isDeviceConnectedToIot = useSelector(selectIsDeviceConnectedToIot);
    const isHolderConnectedToIot = useSelector(selectIsHolderConnectedToIot);
    const isConnectingToIot = useSelector(selectIsConnectingToIot);
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isReconnectCanBeStarted = isDeviceConnectedToIot && isDeviceWebSocketDisconnected && !isConnectingToIot;
    const isHolderReconnectCanBeStarted =
        isDeviceConnectedToIot &&
        isHolderWebSocketDisconnected &&
        !isConnectingToIot &&
        isHolderConnectedToIot &&
        isHolderConnected;

    const startDeviceWebSocketReconnect = async () => {
        try {
            log.info('Starting websocket reconnect for charger');
            await subscribeToSocketsAndWaitConnected();
            dispatch(setIsDeviceWebSocketDisconnected(false));
        } catch (error) {
            deviceStateService.clearDeviceState();
        }
    };

    const startHolderWebSocketReconnect = async () => {
        try {
            log.info('Starting websocket reconnect for holder');
            await subscribeToSocketsAndWaitConnected(true);
            dispatch(setIsHolderWebSocketDisconnected(false));
        } catch (error) {
            mwStateService.clearHolderState();
        }
    };

    useEffect(() => {
        if (!isReconnectCanBeStarted) return;

        startDeviceWebSocketReconnect();
    }, [isReconnectCanBeStarted]);

    useEffect(() => {
        if (!isHolderReconnectCanBeStarted) return;

        startHolderWebSocketReconnect();
    }, [isHolderReconnectCanBeStarted]);
};

export default useIotWebSocketReconnect;
